import { render, staticRenderFns } from "./Ofertas.vue?vue&type=template&id=a17969f4"
import script from "./Ofertas.vue?vue&type=script&lang=js"
export * from "./Ofertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports